// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"59c214f4c6c0b4c0c0a4","351":"ed64c47fe144e9ddd422","532":"240e522233f2f41928c8","691":"e83ab71c5c4b7fed6a26"}[chunkId] + ".js";
};